:host {
  display: block;
  font-family: var(--ls-font-family);
}
